export default __webpack_public_path__ + "static/summit_stars_5-04d24932e487cc025521f83110bdfd9a.svg";